import React, { createContext } from 'react';

export const RedeemContext = createContext();

export const RedeemContextProvider = ({ children, ...props }) => {
  return (
    <RedeemContext.Provider value={props}>{children}</RedeemContext.Provider>
  );
};
